/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import StatusStepHeader from '../statusStepHeader';
import BackIcon from '../images/caret-left-black.svg';

const commonNotes = [
  'Texted',
  'Left VM',
  'Emailed',
  'Follow Up Later',
  'No Response',
];

const StepTwo = (props) => {
  const {
    state: {
      message,
      messageFocused,
    },
    handleChange,
    handleMessageFocus,
    handleMessageBlur,
    updateState,
    collapsible,
  } = props;

  const [collapsed, setCollapsed] = useState(true);

  const handleCommonNote = ({ target }) => {
    const { value } = target;

    const messageList = [];

    if (message.length > 0) {
      messageList.push(message);
    }

    if (!messageFocused) {
      messageList.push(value);
    }

    updateState({ message: messageList.join('. ') });
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const header = () => {
    const arrowClassList = ['options-arrow'];

    if (collapsed) {
      arrowClassList.push('selected');
    }

    if (collapsible) {
      return (
        <div className="action-headline">
          <button
            type="button"
            className="collapse-button"
            onClick={toggleCollapsed}
          >
            <StatusStepHeader
              step="2"
              stepComplete={message.length > 0}
            >
              Add an update to the referral timeline (optional)
            </StatusStepHeader>
            <img
              alt=""
              className={arrowClassList.join(' ')}
              src={BackIcon}
            />
          </button>
        </div>
      );
    }

    return (
      <div className="action-headline">
        <StatusStepHeader
          step="2"
          stepComplete={message.length > 0}
        >
          Add an update to the referral timeline (optional)
        </StatusStepHeader>
      </div>
    );
  };

  const bodyClassList = ['notify-loop-action-body'];
  const textAreaOverlayClasslist = ['textarea-overlay'];

  if (collapsed) {
    bodyClassList.push('collapsed');
  }

  if (messageFocused) {
    textAreaOverlayClasslist.push('hidden');
  }

  return (
    <div className="step-2">
      <div className={bodyClassList.join(' ')}>
        {header()}
        <div className="action-details textarea-overlay-container medium-bold-font">
          <textarea
            maxLength={1400}
            name="message"
            onChange={handleChange}
            className="large-slim-font rea-black"
            placeholder="This update is visible to you and our support team"
            value={message}
            onFocus={handleMessageFocus}
            onBlur={handleMessageBlur}
          />
          <div className={textAreaOverlayClasslist.join(' ')}>
            <label>
              <span className="small-font gray-400">Most common notes</span>
              <div className="textarea-overlay-buttons">
                {
                  commonNotes.map((value, idx) => (
                    <input
                      key={idx}
                      type="button"
                      value={value}
                      className="medium-slim-font rea-orange"
                      onClick={handleCommonNote}
                    />
                  ))
                }
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepTwo;

StepTwo.defaulProps = {
  collapsible: false,
};
